import { mapState, mapMutations } from 'vuex'
import ServiceDropboxSelector from '@/components/Ui/ServiceDropboxSelector'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'SlideshowItem',
  components: {
    ServiceDropboxSelector
  },
  props: {
    index: Number
  },
  data () {
    return {
      input: {
        uuid: null,
        isDefaultFocusedFlg: 0,
        dropBoxFile: {
          serviceDropboxUuid: '',
          fileType: 3,
        }
      },

      // Dropboxのファイルタイプをスライドショー固定する
      fixedFileType: 3,

      // データの初期化終了フラグ
      inited: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName,

      // form
      serviceId: state => state.serviceScreenSettingForm.serviceId,
      serviceContentsId: state => state.serviceScreenSettingForm.targetId,
      contentsScreenId: state => state.serviceScreenSettingForm.targetId,
      values: state => state.serviceScreenSettingForm.values,
    }),

    dropboxSelectorModel () {
      // console.log('input', JSON.stringify(this.input))
      return {
        fileType: this.fixedFileType,
        serviceDropboxUuid: this.input.dropBoxFile.serviceDropboxUuid
      }
    },

    // validate
    formIsValid () {
      return this.validate('serviceDropboxUuid')
    },

    // jsonb
    getJsonb () {
      const data = $.extend(true, {}, this.input);
      data.isDefaultFocusedFlg = this.input.isDefaultFocusedFlg
        ? 1 : 0;
      return data
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'slideshow',
          index: this.index,
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'serviceScreenSettingForm/setValidate'
    }),

    /**
     * 初期化
     */
    init () {
      let data = $.extend(true, this.input, this.values.screenSlideShowSettings[this.index])
      this.$set(this, 'input', data)

      // データの初期化完了
      this.$nextTick(() => {
        this.inited = true
      })
    },

    /**
     * Dropbox設定の変更
     */
    changeDropboxValue (props) {
      this.input.dropBoxFile.fileType = props.value.fileType
      this.input.dropBoxFile.serviceDropboxUuid = props.value.serviceDropboxUuid
    },

    /**
     * バリデート
     */
    validate (key) {
      switch (key) {
        case 'serviceDropboxUuid':
          return Validator.validSelect(this.input.dropBoxFile.serviceDropboxUuid)
      }
    },
  }
}
